import { lang } from '@umu/ukit-lang';
import { Button, Modal } from '@umu/umu-design';
import { If } from 'common/src/components';
import React, { useEffect, useState } from 'react';
import Iframe from '../../../@iframe/iframe';
import { $document, $window } from '@umu/umu-dom';
import { downloadByAnchor } from '../../../../@utils';

interface IMicroDetailPreviewProps {
    id?: string;
    shareUrl: string;
    pageName: string;
    hideDownButton?: boolean;
    downButtonText?: string;
    onClose?: () => void;
}
const { confirm } = Modal;

const MicroDetailPreviewPage = (props: IMicroDetailPreviewProps) => {
    const [isShowFooter, setIsShowFooter] = useState(false);
    const [isDown, setIsDown] = useState(false);
    const { shareUrl, hideDownButton = false, downButtonText = lang('下载图片'), id = 'micro-page-preview-id' } = props;
    const onExportToImg = async () => {
        const iframe: any = $document.getElementById(id);
        if (!iframe) {
            return;
        }
        setIsDown(true);
        iframe?.contentWindow?.postMessage?.(
            JSON.stringify({
                type: 'downPageLoad',
                data: {
                    blockId: 'downPageLoad',
                    fromTo: 'web',
                },
            }),
            '*',
        );
    };
    useEffect(() => {
        const handleMessage = async (event: any) => {
            // 确保消息是从我们期望的iframe发送的
            if (event.data) {
                const { type = '', data } = event.data;
                const imgList = data?.imgUrlList || [];
                if (type === 'downPageLoad' && data?.fromTo === 'microPage' && data?.blockId === 'downPageLoad') {
                    let yOffset = 0;
                    const canvas = $document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    canvas.width = data.width;
                    canvas.height = data.height;
                    for (let i = 0; i < imgList.length; i++) {
                        // 部分延迟，确保图片加载完成
                        await new Promise((r) => {
                            const img = new Image();
                            img.src = imgList[i];
                            img.onload = () => {
                                r(img);
                                context?.drawImage(img, 0, yOffset);
                                yOffset += img.height;
                            };
                            img.onerror = () => {
                                r(null);
                            };
                        });
                    }
                    const longScreenshot = canvas.toDataURL();
                    downloadByAnchor(longScreenshot, data?.title);
                    setIsDown(false);
                }
            }
        };
        $window.addEventListener('message', handleMessage);

        // 移除事件监听器
        return () => {
            $window.removeEventListener('message', handleMessage);
        };
    }, []);
    return (
        <div className="micro-page-preview-page">
            <div className="micro-page-preview-page-content">
                <Iframe url={shareUrl} id={id} topOffset="30vh - 1.6rem" onLoad={() => setIsShowFooter(true)} />
            </div>
            <If condition={!hideDownButton && isShowFooter}>
                <div className="micro-page-preview-page-footer">
                    <Button type="primary-blue" disabled={isDown} onClick={onExportToImg}>
                        {downButtonText}
                    </Button>
                </div>
            </If>
        </div>
    );
};
const onPreviewMicroPageDialog = (info: IMicroDetailPreviewProps) => {
    const dialog = confirm({
        title: lang('模版预览'),
        centered: true,
        width: '9.6rem',
        footer: null,
        className: 'micro-page-preview-page-dialog',
        content: (
            <MicroDetailPreviewPage
                {...info}
                onClose={() => {
                    dialog.destroy();
                    info?.onClose?.();
                }}
            />
        ),
    } as any);
    return dialog;
};
export { onPreviewMicroPageDialog };
